module.exports = __webpack_public_path__ + "images/product-navigation/usb-charging-dock-18d19ac3.svg";